import "./tab2.scss"
import * as React from "react";
import {useState} from "react";
import SettingCard, {ISettingCard} from "../../../../../../ui/settingcard/settingcard";
import DotIndicator from "../../../../../../ui/dotindicator/dotindicator";
import MultiSelectDropzone, {choosedFile} from "../../../../../../ui/dropzone/multiselect/multielectdropzone";
import Toggle from "../../../../../../ui/toggle/toggle";
import Alert from "../../../../../../ui/alert/alert";

const Tab2 = () => {
    const [selectedFiles, setSelectedFiles] = useState<choosedFile[]>([]);
    const [activateTeaser, setActivateTeaser] = useState("setting0");
    const [alert, setAlert] = useState(false);
    const teaserItems: ISettingCard[] = [
        {
            title: "تیزر دارم",
            body: "تیزر باید با استانداردهای صدا و سیما همانگی داشته باشد",
            id: 0,
            activate: activateTeaser,
            setActivate: setActivateTeaser
        },
        {
            title: "تیزر ندارم",
            body: "می توانید برای ساخت تیزر درخواست دهید",
            id: 1,
            activate: activateTeaser,
            setActivate: setActivateTeaser
        }
    ]
    return (
        <div className="Tab2">
            <div className="row pt-3">
                <div className="d-flex align-items-center pt-3 pb-2 mb-4">
                    <DotIndicator size={"16px"}/>
                    <span>نوع تبلیغ</span>
                </div>
                {
                    teaserItems.map((teaserItem, index) => {
                        return (
                            <div className="col-lg-5 col-md-6 col-12 mb-2">
                                <SettingCard activate={teaserItem.activate} title={teaserItem.title}
                                             body={teaserItem.body}
                                             setActivate={teaserItem.setActivate} id={index}/>
                            </div>
                        );
                    })
                }
            </div>
            <div className="row pt-3">
                {
                    activateTeaser === "setting0" ?
                        <div className="col-12">
                            <span>آپلود تیزر تبلیغاتی</span>
                            <br/>
                            <MultiSelectDropzone setSelectedImages={setSelectedFiles}/>
                        </div>
                        :
                        <div className="col-6">
                            <Toggle onClick={() => {
                                setAlert(!alert)
                            }} checked={false} label={"درخواست ساخت تیزر"}/>
                            {
                                alert ?
                                    <Alert type={"Info"}>کارشناس تا ۴۸ ساعت آینده با شما تماس می گیرد.</Alert>
                                    :
                                    null
                            }
                        </div>
                }
            </div>
        </div>
    );
}

export default Tab2